import router from './router'
import MainMessages from './localization'
import { useToastStore } from './store'

export default {
  router,
  useToastStore,
  localization: MainMessages,
}
